import { Chip } from "@relex-solutions/fragments"
import { memo } from "react"
import type { Module } from "@/domains/customers/types/Module"
import styles from "./ModuleFamily.module.css"

interface ModuleFamilyProps {
  family: string
  modules: Module[]
}

export const ModuleFamily = memo(({ family, modules }: ModuleFamilyProps) => (
  <div>
    <span className="fr-text-300-strong">{family}</span>
    <div className={styles.chipContainer} data-testid="module-chip-container">
      {modules.map((module) => (
        <Chip key={module.id} label={module.name} variant="filled" color="green" />
      ))}
    </div>
  </div>
))

ModuleFamily.displayName = "ModuleFamily"
